import { unsafeCSS, html } from "lit";
import { property } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { e } from "../../scoped-registry-mixin-2fqf-E5n.js";
import { LeafElement } from "../../components/leaf-element.js";
import "../../components/button/button.js";
import { LeafButton } from "../../components/button/button.component.js";
const styles = "/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n:host {\n  display: block;\n}\n\n.chc-c-skiplink {\n  opacity: 0;\n  padding: var(--leaf-spacing-8);\n  position: absolute;\n  transform: translateY(-1000px);\n  transition: opacity 0.6s, visibility 0.6s linear;\n  width: -moz-max-content;\n  width: max-content;\n  z-index: var(--leafdcws-z-index-50);\n}\n.chc-c-skiplink:focus-within {\n  opacity: 1;\n  transform: translateY(0px);\n  z-index: var(--leafdcws-z-index-50);\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const CHC_STICKY_BANNER = "chc-sticky-banner";
const _CHCSkiplink = class _CHCSkiplink extends e(LeafElement) {
  observerStickyBannerChange(element) {
    var _a, _b;
    const bannerElement = (_b = (_a = document.querySelector(CHC_STICKY_BANNER)) == null ? void 0 : _a.shadowRoot) == null ? void 0 : _b.querySelector(".chc-c-sticky-banner");
    if (bannerElement) {
      const observer = new MutationObserver((mutationList) => {
        const { target } = mutationList.find((m) => m.attributeName === "class") || {};
        if (target) {
          setTimeout(() => {
            this.updateScrollMargin();
            element == null ? void 0 : element.scrollIntoView({ behavior: "smooth" });
            observer.disconnect();
          }, 100);
        }
      });
      observer.observe(bannerElement, {
        attributes: true,
        attributeFilter: ["class"]
      });
    }
  }
  handleClick(e2) {
    var _a, _b;
    e2.preventDefault();
    const target = this.target;
    let element = document.querySelector(`${target}`);
    const tabIndex = "-1";
    if (target === "#chc-footer" && document.querySelector(CHC_STICKY_BANNER) !== null) {
      this.observerStickyBannerChange(element);
    } else {
      element == null ? void 0 : element.scrollIntoView({ behavior: "smooth" });
    }
    if (target === "#main") {
      const allFirstElements = Array.from(
        document.querySelectorAll("leaf-breadcrumbs, chc-hero[data-audience], leaf-alert, chc-hero")
      );
      const getBreadcrumb = allFirstElements.findIndex((element2) => element2.tagName.includes("BREADCRUMBS"));
      const firstElementAfterBreadcrumbs = getBreadcrumb > -1 ? getBreadcrumb + 1 : 0;
      element = allFirstElements[firstElementAfterBreadcrumbs];
    } else if (target === "#chc-header") {
      element = (_b = (_a = document.querySelector("chc-header")) == null ? void 0 : _a.shadowRoot) == null ? void 0 : _b.querySelector(`[id="chc-header"]`);
    }
    element == null ? void 0 : element.setAttribute("tabindex", tabIndex);
    element == null ? void 0 : element.classList.add("no-focus-visible-outline");
    element.focus();
  }
  updateScrollMargin() {
    var _a, _b;
    const contentElement = (_b = (_a = document.querySelector(CHC_STICKY_BANNER)) == null ? void 0 : _a.shadowRoot) == null ? void 0 : _b.querySelector(".chc-c-sticky-banner__content");
    const bannerHeight = contentElement == null ? void 0 : contentElement.clientHeight;
    document.documentElement.style.setProperty("--chc-sticky-banner-scroll-margin", `${bannerHeight}px`);
  }
  render() {
    return html`<div class="chc-c-skiplink">
      <leaf-button href=${ifDefined(this.target)} @click="${this.handleClick}">
        <slot></slot>
      </leaf-button>
    </div>`;
  }
};
_CHCSkiplink.styles = unsafeCSS(styles);
_CHCSkiplink.elementDefinitions = {
  "leaf-button": LeafButton
};
let CHCSkiplink = _CHCSkiplink;
__decorateClass([
  property({ reflect: true })
], CHCSkiplink.prototype, "target", 2);
export {
  CHCSkiplink
};
//# sourceMappingURL=skiplink.component.js.map
